import { LOOM_SHARE_PAGE_REGEX_STR } from '../validate';

export type Fn = (a: string, b: string) => string;

export const getVideoURL: Fn = (videoID, url) => {
  return `${url}/share/${videoID}`;
};

export const getVideoAliasURL: Fn = (videoAliasID, url) => {
  return `${url}/a/${videoAliasID}`;
};

export const getOEmbedShareURL: Fn = (videoID, url) =>
  `${url}/v1/oembed?url=${global.encodeURIComponent(
    getVideoURL(videoID, url)
  )}`;

export const getOEmbedAliasURL: Fn = (videoAliasID, url) =>
  `${url}/v1/oembed?url=${global.encodeURIComponent(
    getVideoAliasURL(videoAliasID, url)
  )}`;

export type GetLoginRedirectUrlFn = (a: any, b: any, c: string) => string;

export const getloginUrlWithRedirect: GetLoginRedirectUrlFn = (
  redirect = null,
  loginCustomTitle = null,
  loginUrl
) => {
  const url = new URL(loginUrl);

  if (redirect) {
    url.searchParams.append('redirect_after', redirect);
  }

  if (loginCustomTitle) {
    url.searchParams.append('custom_title', loginCustomTitle);
  }

  return url.toString();
};

// pathname is of the form `/share/:videoId`, so pull out everything after
// the second slash and remove any query params after.
export const getVideoIdFromSharePageUrl = (url: string): string | null => {
  if (!url) {
    return null;
  }

  const loomRegex = new RegExp(LOOM_SHARE_PAGE_REGEX_STR);
  const videoSharePageUrl = new URL(url);

  if (!loomRegex.test(url)) {
    return null;
  }

  return videoSharePageUrl?.pathname?.split('/')[2]?.split(/[^A-Za-z0-9]/)[0];
};

export type WithParamFn = (a: string, b: string, url: string) => string;

export const withParam: WithParamFn = (name, value, url) => {
  const newUrl = new URL(url);

  newUrl.searchParams.append(name, value);

  return newUrl.toString();
};
